import {addLanguage} from '../../redux/reducers/languageSlice'
import {useDispatch} from 'react-redux'
import {addCohort} from '../../redux/reducers/cohortSlice'
import {useNavigate} from 'react-router-dom'
import axios from 'axios'
import api from '../../../_metronic/helpers/api'
import {showAlert} from '../../redux/reducers/alertSlice'
import {stringify} from 'qs'
import {addCourse} from '../../redux/reducers/CourseSlice'
import {addCategory} from '../../redux/reducers/categorySlice'
import { addSeason } from '../../redux/reducers/seasonSlice'

function useUtils() {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const fetchPrograms = async (
    text = null,
    status = null,
    cohortId = null,
    categoryId = null,
    seasonId = null,
    limit = 10,
    offset = 0
  ) => {
    const params = {
      limit,
      offset,
      relations: ['programCohort.cohort', 'category', 'language', 'season'],
      where: {},
    }

    if (text) {
      params.text = text
    }

    if (status && status !== 'Status') {
      params.where.status = status
    }

    if (cohortId && cohortId !== 'Cohort') {
      params.where.cohortId = cohortId
    }

    if (categoryId && categoryId !== 'Category') {
      params.where.categoryId = categoryId
    }

    if (seasonId && seasonId !== 'Season') {
      params.where.seasonId = seasonId
    }

    try {
      const response = await api.get(`/program?${stringify(params)}`)
      if (response.data.status) {
        return response.data.data
      }
    } catch (error) {
      dispatch(
        showAlert({
          message: error?.response?.data?.message ?? 'Network error',
          variant: 'danger',
        })
      )
    }
  }

  const createProgram = async (values, bannerMediaId, squareMediaId) => {
    try {
      let data = {
        code: values.code,
        title: values.title,
        authorName: values.authorName,
        cohortIds: values.cohortIds,
        languageId: values.languageId,
        categoryId: values.categoryId,
        bannerMediaId,
        squareMediaId,
        shortDescription: values.shortDescription,
        longDescription: values.longDescription,
        tags: values.tags,
        courseIds: values.courseIds,
        learningPoints: values.learningPoints,
        isFeatured: values.isFeatured,
        isForBlackforceMember: values?.isForBlackforceMember, // 
        seasonId: values?.seasonId, //
      }
      const response = await api.post(`/program`, data)
      if (values.isClone) {
        dispatch(showAlert({message: 'Program Cloned', variant: 'success'}))
        navigate('/programlist')
    } else {
      if (response?.data?.status) {
        values = {...values, id: response?.data?.data.id, status: null}
        dispatch(showAlert({message: 'Program Created', variant: 'success'}))
        navigate('/programlist/preview-program', {state: {values}})
      }}
    } catch (error) {
      dispatch(showAlert({message: error?.response?.data?.message || 'Network error', variant: 'danger'}))
    }
  }

  const uploadImage = async (values) => {
    if (values.bannerMediaId && values.squareMediaId) {
      createProgram(values, values.bannerMediaId, values.squareMediaId)
    } else {
      try {
        let bannerMediaId = values.bannerMediaId
        let squareMediaId = values.squareMediaId

        // Upload banner image if it's new
        if (values.bannerImage && !values.bannerMediaId) {
          const uniqueFileName = `banner_${Date.now()}`
          const imageFile = values.bannerImage
          const fileType = imageFile.type
          const fileSize = `${imageFile.size}`

          const uploadDetails = {
            fileName: uniqueFileName,
            fileType: fileType,
            size: fileSize,
          }

          const uploadResponse = await api.post('s3/upload-url', uploadDetails)
          const {mediaId, signedUrl} = uploadResponse.data.data

          const imageUploadResponse = await axios.put(signedUrl, imageFile, {
            headers: {
              'Content-Type': fileType,
            },
          })
          if (imageUploadResponse.status !== 200) {
            throw new Error('Banner image upload failed')
          }
          bannerMediaId = mediaId
        }

        // Upload square image if it's new
        if (values.squareImage && !values.squareMediaId) {
          const uniqueFileName = `square_${Date.now()}`
          const imageFile = values.squareImage
          const fileType = imageFile.type
          const fileSize = `${imageFile.size}`

          const uploadDetails = {
            fileName: uniqueFileName,
            fileType: fileType,
            size: fileSize,
          }

          const uploadResponse = await api.post('s3/upload-url', uploadDetails)
          const {mediaId, signedUrl} = uploadResponse.data.data

          const imageUploadResponse = await axios.put(signedUrl, imageFile, {
            headers: {
              'Content-Type': fileType,
            },
          })
          if (imageUploadResponse.status !== 200) {
            throw new Error('Square image upload failed')
          }
          squareMediaId = mediaId
        }

        createProgram(values, bannerMediaId, squareMediaId)
      } catch (error) {
        console.log('Error uploading images:', error, error.message)
      }
    }
  }
  const publishProgram = async (id) => {
    try {
      const response = await api.patch(`program/${id}`, {status: 'published'})
      console.log(response)
      if (response.data.status) {
        dispatch(showAlert({message: 'Program Published', variant: 'success'}))
        navigate('/programlist')
      }
    } catch (error) {
      // dispatch(showAlert({message: error?.response?.data?.message, variant: 'danger'}))
    }
  }

  const handleEdit = async (id) => {
    const params = {
      relations: ['programCohort.cohort', 'category', 'language', 'programCourse.course', 'learningPoint', 'tag', 'season'],
    }

    try {
      const response = await api.get(`/program/${id}?${stringify(params)}`)
      if (response.data.status) {
        return response.data.data
      }
    } catch (error) {}
  }

  const fetchCategories = async () => {
    try {
      const response = await api.get(
        `/category?select[id]=true&select[name]=true&select[createdAt]=true&order[name]=ASC`,
        {
          params: {
            returnAllRecords: true,
            offset: 0,
          },
        }
      )
      if (response.data.status) {
        dispatch(addCategory(response.data.data))
      }
    } catch (error) {}
  }

  const fetchLanguages = async () => {
    try {
      const response = await api.get(
        `/language?select[id]=true&select[name]=true&select[createdAt]=true&order[name]=ASC`,
        {
          params: {
            returnAllRecords: true,
            offset: 0,
          },
        }
      )
      if (response.data.status) {
        dispatch(addLanguage(response.data.data))
      }
    } catch (error) {}
  }

  const fetchCohorts = async () => {
    try {
      const response = await api.get(
        `/cohort?select[id]=true&select[title]=true&select[createdAt]=true&order[title]=ASC`,
        {
          params: {
            returnAllRecords: true,
            offset: 0,
          },
        }
      )
      if (response.data.status) {
        dispatch(addCohort(response.data.data))
      }
    } catch (error) {}
  }

  const fetchCourses = async (categoryId, languageId) => {
    const params = {
      returnAllRecords: true,
      offset: 0,
      where: {},
    }

    if (categoryId) {
      params.where.categoryId = categoryId
    }

    if (languageId ) {
      params.where.languageId = languageId
    }

    try {
      const response = await api.get(
        `/course?${stringify(
          params
        )}&select[id]=true&select[title]=true&select[createdAt]=true&order[title]=ASC`
      )
      if (response.data.status) {
        dispatch(addCourse(response.data.data))
      }
    } catch (error) {
      // dispatch(showAlert({message:error?.response?.data?.message,
      //     variant:'danger'
      // }));
    }
  }

  const fetchSeasons = async () => {
    const params = {
      returnAllRecords: true,
      offset: 0,
    }

    try {
      const response = await api.get(
        `/season?${stringify(params)}&select[id]=true&select[name]=true&order[name]=ASC`
      )
      if (response.data.status) {
        dispatch(addSeason(response.data.data))
      }
    } catch (error) {
      console.log(error?.message)
    }
  }

  const deleteProgram = async (id, limit, offset) => {
    try {
      const response = await api.delete(`/program/${id}`)
      if (response?.data?.status) {
        dispatch(showAlert({message: 'Program deleted', variant: 'success'}))
        return fetchPrograms(null, null, null, null, null, limit, offset)
      }
    } catch (error) {
      // dispatch(showAlert({message:error?.response?.data?.message,
      //     variant:'danger'
      // }));
    }
  }

  const fetchAllPrograms = async (text = null,
    status = null,
    cohortId = null,
    categoryId = null,
    seasonId = null,) => {
    const params = {
      limit: 100,
      offset: 0,
      order: {createdAt: 'DESC'},
      relations: ['programCourse', 'learningPoint', 'tag'],
      where: {},
    }

    if (text) {
      params.text = text
    }

    if (status && status !== 'Status') {
      params.where.status = status
    }

    if (cohortId && cohortId !== 'Cohort') {
      params.where.cohortId = cohortId
    }

    if (categoryId && categoryId !== 'Category') {
      params.where.categoryId = categoryId
    }

    if (seasonId && seasonId !== 'Season') {
      params.where.seasonId = seasonId
    }

    let allData = []
    let totalRecords = 0
    try {
      const initialResponse = await api.get(`/program?${stringify(params)}`)
      if (initialResponse.data.status) {
        totalRecords = initialResponse.data.data.count
        allData = initialResponse.data.data.records

        const totalChunks = Math.ceil(totalRecords / params.limit)
        const promises = []

        for (let i = 1; i < totalChunks; i++) {
          params.offset = i * params.limit
          promises.push(api.get(`/program?${stringify(params)}`))
        }

        const responses = await Promise.all(promises)
        responses.forEach((response) => {
          if (response.data.status) {
            allData = [...allData, ...response.data.data.records]
          }
        })

        if (allData?.length > 0) {
          return allData?.map((program) => ({
            id: program.id,
            title: program?.title,
            authorName: program?.authorName,
            code: program?.code,
            shortDescription: program?.shortDescription,
            longDescription: program?.longDescription,
            cohort: program?.cohortId,
            language: program?.languageId,
            category: program?.categoryId,
            courses: program?.programCourse?.map((item) => item?.courseId).filter(Boolean),
            season: program?.seasonId,
            isFeatured: program?.isFeatured || false,
            ForBlackforceMember: program?.isForBlackforceMember || false,
            tags: program?.tag?.map((item) => item?.name),
            learningPoints: program?.learningPoint?.map((item) => item?.name),
          }))
        }
      }
    } catch (error) {
      dispatch(
        showAlert({
          message: error?.response?.data?.message ?? 'Network error',
          variant: 'danger',
        })
      )
    }
  }

  const addCSV = async (data) => {
    try {
      const response = await api.post(`/program/add-bulk`, data)
      if (response?.data?.status) {
        return response?.data?.data
      }
    } catch (error) {
      dispatch(showAlert({message: error?.response?.data?.message, variant: 'danger'}))
    }
  }

  const submitReport = async(data) =>{
    try {
      const response = await api.post(
        `/setting/sendCSVReport`, data)
       return response
    } catch (error) {
      
    }
  }

  return {
    addCSV,
    fetchCategories,
    fetchCohorts,
    fetchPrograms,
    fetchLanguages,
    fetchCourses,
    publishProgram,
    uploadImage,
    handleEdit,
    deleteProgram,
    fetchAllPrograms,
    fetchSeasons,
    submitReport
  }
}

export default useUtils
